import React from 'react';
import { Box, Text } from '@hopskipdrive/react-components';

import { Container } from './styles';

const AccessDenied: React.FC = () => {
  return (
    <Container>
      <Box display="flex" alignItems="flex-start" flexDirection="column" gap="26px">
        <Box display="flex">
          <Text variant="h5" textColor="primaryText" fontWeight={600} mr={4}>
            Access Denied
          </Text>
        </Box>

        <Text variant="body2" textColor="secondaryText" fontWeight={400}>
          This page is not available to this account.
        </Text>
      </Box>
    </Container>
  );
};

export default AccessDenied;
